import(/* webpackMode: "eager", webpackExports: ["PageDraft"] */ "/vercel/path0/app/(frontend)/[...slug]/draft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CallToActionDraft"] */ "/vercel/path0/components/call-to-action/draft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedLinkDraft"] */ "/vercel/path0/components/content-blocks/featured-links/featured-link/draft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrderFormDraft"] */ "/vercel/path0/components/content-blocks/order-form/draft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrderFormRender"] */ "/vercel/path0/components/content-blocks/order-form/render.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterDraft"] */ "/vercel/path0/components/footer/draft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/vercel/path0/components/footer/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/vercel/path0/components/header/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderDraft"] */ "/vercel/path0/components/header/draft.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/image/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InlineLinkDraft"] */ "/vercel/path0/components/inline-link/draft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
